import {
  AddressToBeConfirmedIcon,
  ArrowHeadIcon,
  BrokenGlassIcon,
  CustomerChoiceIcon,
  DoorLockIcon,
  ElectricDamagesIcon,
  EnvironmentalPhenomenonIcon,
  IconDispatcher,
  IconDispatcherProps,
  NearestGarageIcon,
  PiledCoinsIcon,
  PlumberIcon as AlexandriaPlumberIcon,
  SecuritySurveillanceIcon,
  TechnicalServiceIcon,
  ThreeDotsIcon,
  SynergyDTIcons,
} from '@integration/alexandria-ui';
import AntenistaIcon from './AntenistaIcon';
import AttachedDocumentIcon from './AttachedDocumentIcon';
import CarpenterIcon from './CarpenterIcon';
import CarpMetalIcon from './CarpMetalIcon';
import CerrajeroApertIcon from './CerrajeroApertIcon';
import CertEnergiaIcon from './CertEnergiaIcon';
import CristaleroIcon from './CristaleroIcon';
import DesatascosIcon from './DesatascosIcon';
import DiggerIcon from './Digger';
import DocumentApprovedIcon from './DocumentApprovedIcon';
import DocumentRefusedIcon from './DocumentRefusedIcon';
import ElectricistaIcon from './ElectricistaIcon';
import EnmoquetadorIcon from './EnmoquetadorIcon';
import GardenerIcon from './GardenerIcon';
import HeatingIcon from './HeatingIcon';
import HomeManagerIcon from './HomeManagerIcon';
import IndemnizableIcon from './IndemnizableIcon';
import InstaGasIcon from './InstaGasIcon';
import LeakIcon from './LeakIcon';
import LimpiezaIcon from './LimpiezaIcon';
import ManitasIcon from './ManitasIcon';
import ManitasInformaticoIcon from './ManitasInformaticoIcon';
import MarmolistaIcon from './MarmolistaIcon';
import MasonIcon from './MasonIcon';
import OtherIcon from './Other';
import PainterIcon from './PainterIcon';
import ParquetIcon from './ParquetIcon';
import PeritoIcon from './PeritoIcon';
import PersianaIcon from './PersianaIcon';
import PestControlIcon from './PestControlIcon';
import PlumberIcon from './PlumberIcon';
import PlungerIcon from './PlungerIcon';
import PoolIcon from './PoolIcon';
import RoofIcon from './RoofIcon';
import SeguridadIcon from './SeguridadIcon';
import ServicioTecnicoIcon from './ServicioTecnicoIcon';
import SewerIcon from './Sewer';
import StackedCoinIcon from './StackedCoinIcon';
import TapiceroIcon from './TapiceroIcon';
import ToldoIcon from './ToldoIcon';
import WCIcon from './WCIcon';
import WorldIcon from './WorldIcon';
import WrappedCheckIcon from './WrappedCheckIcon';
import { TypedMap } from 'ts/types/common.types';

const {
  BatteryIcon,
  CollisionIcon,
  DrivingIcon,
  EnginesIcon,
  FuelIcon,
  GarageIcon,
  GearIcon,
  GeolocationIcon,
  HeatingIcon: MotorHeatingIcon,
  IncidentIcon,
  KeysIcon,
  MotorcycleIcon,
  OtherIcon: MotorOtherIcon,
  OutOfRoadIcon,
  PlaceIcon,
  TowIcon,
  WarningLightIcon,
  WheelIcon,
} = SynergyDTIcons;

export const iconsAdapter: TypedMap<Function> = {
  ALEXANDRIA_BROKEN_GLASS: BrokenGlassIcon,
  ALEXANDRIA_DOOR_LOCK: DoorLockIcon,
  ALEXANDRIA_ELECTRIC_DAMAGES: ElectricDamagesIcon,
  ALEXANDRIA_ENVIRONMENTAL_PHENOMENON: EnvironmentalPhenomenonIcon,
  ALEXANDRIA_PILED_COINS: PiledCoinsIcon,
  ALEXANDRIA_PLUMBER: AlexandriaPlumberIcon,
  ALEXANDRIA_SECURITY_SURVEILLANCE: SecuritySurveillanceIcon,
  ALEXANDRIA_TECHNICAL_SERVICE: TechnicalServiceIcon,
  ALEXANDRIA_THREE_DOTS: ThreeDotsIcon,
  ACCOUNT_EXPERT: PeritoIcon,
  ACCOUNT_EXPERT_2: PeritoIcon,
  ACCOUNT_EXPERT_3: PeritoIcon,
  ALBANIL: MasonIcon,
  ANTENISTA: AntenistaIcon,
  ANTENNIST: AntenistaIcon,
  ARROW_HEAD_ICON: ArrowHeadIcon,
  AWNINGS: ToldoIcon,
  BUILDER: MasonIcon,
  CALEFACCION: HeatingIcon,
  CAMION_DESATASCOS: DesatascosIcon,
  CARPENTER: CarpenterIcon,
  CARPENTER_METAL: CarpMetalIcon,
  CARPETER: EnmoquetadorIcon,
  CARPINTERO: CarpenterIcon,
  CARPINTERO_METAL: CarpMetalIcon,
  CERRAJERO: CerrajeroApertIcon,
  CERRAJERO_APERTURAS: CerrajeroApertIcon,
  CERTIFICADOR_ENERGETICO: CertEnergiaIcon,
  CLEANING: LimpiezaIcon,
  CRISTALERO: CristaleroIcon,
  CUSTOMER_CHOICE: CustomerChoiceIcon,
  CUSTOMER_CHOICE_TBD: AddressToBeConfirmedIcon,
  DEFAULT: ServicioTecnicoIcon,
  DIGGER: DiggerIcon,
  ELECTRICISTA: ElectricistaIcon,
  ELECTRICAL_TECHNICIAN: ElectricistaIcon,
  ENERGY_CERTIFIER: CertEnergiaIcon,
  ENMOQUETADOR: EnmoquetadorIcon,
  FONTANERO: PlumberIcon,
  GARDNER: GardenerIcon,
  GAS: InstaGasIcon,
  GAS_INSTALLER: InstaGasIcon,
  GLAZIER: CristaleroIcon,
  GLASSWORKER: CristaleroIcon,
  HEATING: HeatingIcon,
  HOME: HomeManagerIcon,
  INDEMNIBLE: IndemnizableIcon,
  INDEMNIZABLE: IndemnizableIcon,
  INSTALADOR_GAS: InstaGasIcon,
  LEAK: LeakIcon,
  LIMPIEZA: LimpiezaIcon,
  LOCKSMITH: CerrajeroApertIcon,
  LOCKSMITH_OPENINGS: CerrajeroApertIcon,
  LOZA_SANITARIA: WCIcon,
  MARMOLIST: MarmolistaIcon,
  MARMOLISTA: MarmolistaIcon,
  NEAREST_GARAGE: NearestGarageIcon,
  PAINTER: PainterIcon,
  PARQUETISTA: ParquetIcon,
  PARTICIPATOR: ParquetIcon,
  PARTNER_HANDYMAN: ManitasIcon,
  PARTNER_HANDYMAN_TECH: ManitasInformaticoIcon,
  PARTNER_MANITAS: ManitasIcon,
  PARTNER_MANITAS_TECNOLOGICO: ManitasInformaticoIcon,
  PERITO: PeritoIcon,
  PERITO2: PeritoIcon,
  PERITO_VERIFICADOR: PeritoIcon,
  PERSIANIST: PersianaIcon,
  PERSIANISTA: PersianaIcon,
  PEST_CONTROL: PestControlIcon,
  PINTOR: PainterIcon,
  PISCINAS: PoolIcon,
  PLUMBER: PlumberIcon,
  PLUNGER: PlungerIcon,
  POOLS: PoolIcon,
  OTHER: OtherIcon,
  REPARADOR_TEJADOS: RoofIcon,
  REIMBURSEMENT_COMPLETED: StackedCoinIcon,
  REIMBURSEMENT_COMPLETELY_APPROVED: DocumentApprovedIcon,
  REIMBURSEMENT_CREATED: WrappedCheckIcon,
  REIMBURSEMENT_DOCUMENTS_VALIDATED: AttachedDocumentIcon,
  REIMBURSEMENT_PARTIALLY_APPROVED: DocumentApprovedIcon,
  REIMBURSEMENT_REFUSED: DocumentRefusedIcon,
  ROOF: RoofIcon,
  SANITARY_WARE: WCIcon,
  SECURITY_VIGILANCE: SeguridadIcon,
  SERVICIO_TECNICO: ServicioTecnicoIcon,
  SEWER: SewerIcon,
  TAPICERO: TapiceroIcon,
  TECHNICAL_SERVICE: ServicioTecnicoIcon,
  TOLDOS: ToldoIcon,
  TRUCK_UNLOCK: DesatascosIcon,
  UPHOLSTERER: TapiceroIcon,
  VIGILANCIA_SEGURIDAD: SeguridadIcon,
  WORLD: WorldIcon,

  BATTERY: BatteryIcon,
  COLLISION: CollisionIcon,
  DRIVING: DrivingIcon,
  ENGINES: EnginesIcon,
  FUEL: FuelIcon,
  GARAGE: GarageIcon,
  GEAR: GearIcon,
  GEOLOCATION: GeolocationIcon,
  INCIDENT: IncidentIcon,
  KEYS: KeysIcon,
  MOTOR_HEATING: MotorHeatingIcon,
  MOTOR_OTHER: MotorOtherIcon,
  MOTORCYCLE: MotorcycleIcon,
  OUT_OF_ROAD: OutOfRoadIcon,
  PLACE: PlaceIcon,
  TOW: TowIcon,
  WARNING_LIGHT: WarningLightIcon,
  WHEEL: WheelIcon,
};

export const computableContractsIconAdapter: TypedMap<string> = {
  FIRST_QUESTION_ELECTRICS: 'mhh-icon-hm-electrics',
  FIRST_QUESTION_GAS: 'mhh-icon-hm-gas',
  FIRST_QUESTION_GLAZING: 'mhh-icon-hm-glazing',
  FIRST_QUESTION_HEATING: 'mhh-icon-hm-heating',
  FIRST_QUESTION_LOCKS: 'mhh-icon-hm-locksmith',
  FIRST_QUESTION_OTHER: 'mhh-icon-hm-others',
  FIRST_QUESTION_PESTS: 'mhh-icon-hm-pest',
  FIRST_QUESTION_PLUMBING_AND_DRAINAGE: 'mhh-icon-hm-plumbing',
  FIRST_QUESTION_ROOFING: 'mhh-icon-hm-roofing',
  FIRST_QUESTION_SECURITY: 'mhh-icon-hm-security',
  FIRST_QUESTION_TELECOM: 'mhh-icon-hm-telecoms',
};

export const getIconByAlexandriaToken = (props: IconDispatcherProps) =>
  IconDispatcher(props);

export const isValueInAlexandriaIcons = (tokenId: string) =>
  tokenId &&
  Object.entries(computableContractsIconAdapter).some(
    entries =>
      entries[0].toLowerCase() === tokenId.toLowerCase() ||
      entries[1].toLowerCase() === tokenId.toLowerCase(),
  );

export const isValueInETLIcons = (tokenId: string) =>
  tokenId &&
  Object.keys(iconsAdapter).some(
    tokenKey => tokenKey.toLowerCase() === tokenId.toLowerCase(),
  );

export const isValueInSomeIcons = (tokenId: string) =>
  tokenId && (isValueInETLIcons(tokenId) || isValueInAlexandriaIcons(tokenId));

export const getIconByProvider = (providerType: string) => {
  const iconName = providerType?.toUpperCase();
  if (isValueInAlexandriaIcons(iconName)) {
    const providerMapped = computableContractsIconAdapter[iconName]
      ? computableContractsIconAdapter[iconName]
      : iconName;
    return () =>
      IconDispatcher({
        iconToken:
          providerMapped.toLowerCase() as IconDispatcherProps['iconToken'],
      });
  }
  return iconsAdapter[iconName] || iconsAdapter['DEFAULT'];
};
